import React, { useState } from 'react';

function Login({ API_URL, onLogin }) {
    const [email, setEmail]   = useState('');
    const [mdp, setMdp]       = useState('');
    const [erreur, setErreur] = useState(false);

    async function login() {
        try {
            const res = await fetch(`${API_URL}/login`, {
                method : 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded', "ngrok-skip-browser-warning": "true" },
                body   : `username=${encodeURIComponent(email)}&password=${encodeURIComponent(mdp)}`
            });
            if (!res.ok) { setErreur(true); return; }
            const data = await res.json();
            setErreur(false);
            onLogin(data.access_token, `${data.prenom} ${data.nom}`);
        } catch(e) {
            setErreur(true);
        }
    }

    return (
        <div style={{
            display        : 'flex',
            alignItems     : 'center',
            justifyContent : 'center',
            width          : '100vw',
            height         : '100vh'
        }}>
            <div style={{ width: '360px', padding: '48px 40px' }}>
                <div style={{ fontSize: '28px', fontWeight: 600, color: 'var(--white)', marginBottom: '8px' }}>
                    Agent Médical
                </div>
                <div style={{ color: 'var(--text-muted)', fontSize: '14px', marginBottom: '40px' }}>
                    Aide à la décision diagnostique
                </div>

                <label style={{ display: 'block', fontSize: '13px', color: 'var(--text-muted)', marginBottom: '6px' }}>
                    Email
                </label>
                <input
                    type        = "email"
                    value       = {email}
                    onChange    = {e => setEmail(e.target.value)}
                    placeholder = "docteur@hopital.tn"
                    onKeyDown   = {e => e.key === 'Enter' && login()}
                    style={{
                        width       : '100%', padding    : '11px 14px',
                        background  : 'var(--bg-light)', border : '1px solid var(--border)',
                        borderRadius: '8px', color      : 'var(--text)',
                        fontSize    : '14px', outline    : 'none'
                    }}
                />

                <label style={{ display: 'block', fontSize: '13px', color: 'var(--text-muted)', marginBottom: '6px', marginTop: '20px' }}>
                    Mot de passe
                </label>
                <input
                    type        = "password"
                    value       = {mdp}
                    onChange    = {e => setMdp(e.target.value)}
                    placeholder = "••••••••"
                    onKeyDown   = {e => e.key === 'Enter' && login()}
                    style={{
                        width       : '100%', padding    : '11px 14px',
                        background  : 'var(--bg-light)', border : '1px solid var(--border)',
                        borderRadius: '8px', color      : 'var(--text)',
                        fontSize    : '14px', outline    : 'none'
                    }}
                />

                <button
                    onClick = {login}
                    style={{
                        width        : '100%', padding      : '11px',
                        background   : 'var(--white)', color        : '#1a1a1a',
                        border       : 'none', borderRadius : '8px',
                        fontSize     : '14px', fontWeight   : 500,
                        cursor       : 'pointer', marginTop    : '28px'
                    }}
                >
                    Connexion
                </button>

                {erreur && (
                    <div style={{ color: '#e06c6c', fontSize: '13px', marginTop: '12px' }}>
                        Email ou mot de passe incorrect
                    </div>
                )}
            </div>
        </div>
    );
}

export default Login;